import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Separator } from "@/components/ui/separator";

interface SmartHistoryPanelProps {
  setInputMessage: (newMessage: string) => void;
}

export default function AfterSalesPanel({
  setInputMessage: _setInputMessage,
}: SmartHistoryPanelProps) {
  return (
    <ScrollArea className="[&>div>div]:!block">
      <Card>
        <CardHeader>
          <CardTitle>Zusammenfassung</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm whitespace-pre-wrap">
            Letzter Kontakt: vor 5 Tagen
          </p>
          <p className="text-sm whitespace-pre-wrap">
            Offene Forderungen: Nein
          </p>
        </CardContent>
      </Card>

      <Separator className="my-3" />

      <Card>
        <CardContent className="pt-4">
          <p className="text-sm whitespace-pre-wrap">Fall 1</p>
        </CardContent>
      </Card>
    </ScrollArea>
  );
}
